import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Modal, ModalHeader, ModalBody, SIZE } from "baseui/modal";
import { FormControl } from "baseui/form-control";
import { Textarea } from "baseui/textarea";
import { useSelector } from "react-redux";
import { Button } from "baseui/button";
import { Select } from "baseui/select";
import { InitialInspectionForm } from "../../initial_inspection_form/initiInspectSections";

const EditInspectModal = ({
  editInspectOpen,
  inspections,
  onClose,
  inspectionObj, //received object from insepctions (editInspectionObj)
}) => {
  const user = useSelector((state) => state.user);
  const [initInspectObj, setInitInspectObj] = useState(null);
  const [currentSection, setCurrentSection] = useState("");
  const [steps, setSteps] = React.useState([]);
  const [filteredSteps, setFilteredSteps] = React.useState([]);
  const [hideNextOptions, setHideNextStatusOptions] = React.useState(true);
  const [editInspectObj, setEditInspectObj] = useState({});
  // const [hideTypeOptions, setHideTypeStatusOptions] = React.useState(false);
  const [isInit, setIsInit] = useState(false);
  const inspectionObjRef = useRef(null);

  useEffect(() => {
    inspectionObjRef.current = [
      parseInt(inspectionObj[0], 10), // Convert the 0th index to an integer
      parseInt(inspectionObj[1], 10), // Convert the 1st index to an integer
      ...inspectionObj.slice(2, 10), // Spread elements from 2 to 9 (unmodified)
      parseInt(inspectionObj[10], 10), // Convert the 10th index to an integer
      parseInt(inspectionObj[11], 10) || null, // Convert the 11th index to an integer or set to null if NaN
    ];

    setEditInspectObj({
      id: inspectionObjRef.current[0] || null,
      inventory_id: inspectionObjRef.current[1] || null,
      inspectionType: null,
      description: inspectionObjRef.current[8] || "",
      next_status: null,
      custRepairId: inspectionObjRef.current[11] !== "Unknown" ? inspectionObjRef.current[11] : null,
    });
  }, [inspectionObj]);

  ///////////////

  useEffect(() => {
    if (editInspectObj.inventory_id !== null && inspections.length > 0) {
      console.log("editInspectObject", editInspectObj);

      const latestInspection = inspections.filter(
        (inspection) => inspection.inventory_id === editInspectObj.inventory_id
      )[0];

      if (latestInspection && latestInspection.id === editInspectObj.id) {
        setHideNextStatusOptions(false);
      }
    } else if (editInspectObj.inventory_id === null && inspections.length > 0) {
      console.log("YOU LANDED IN THE CUSTREPAIRID BLOCK", editInspectObj);
      const latestInspection = inspections.filter(
        (inspection) => inspection.custRepairId === editInspectObj.custRepairId
      )[0];
      console.log(
        "latestInspection inside cust repair block",
        latestInspection
      );
      if (latestInspection && latestInspection.id === editInspectObj.id) {
        setHideNextStatusOptions(false);
      }
    }
  }, [editInspectObj, inspections]);

  /////////////////////////

  //GET STEPS
  const apiUrl = process.env.REACT_APP_API_URL;
  useEffect(() => {
    const fetchSteps = async () => {
      try {
        const response = await axios.get(`${apiUrl}/api/steps`);
        const sortedSteps = response.data.steps
          .map((step) => ({
            id: step.id,
            label: step.step_name,
          }))
          .sort((a, b) => a.id - b.id);

        // Leave off the last 4 steps
        const stepsWithout1OrLast5 = [
          ...sortedSteps.slice(1, 9), // 'Quality Control' to 'key line'
          sortedSteps[13], // 'init_return''
          sortedSteps[20], //'Wholesale'
        ];

        console.log("sortedSteps", sortedSteps);
        console.log("stepsWithout1OrLast5", stepsWithout1OrLast5);

        const repairStepsAdmin = sortedSteps.slice(-6, -1);

        // Update the state with the new array
        setFilteredSteps(
          editInspectObj.custRepairId //if repair order
            ? user.role_id === 2 //and user is admin
              ? repairStepsAdmin //then provide repair steps
              : stepsWithout1OrLast5
            : stepsWithout1OrLast5 // Replace `someOtherSteps` with the default or fallback steps if `custRepairId` is falsy
        );

        setSteps(sortedSteps);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (steps.length === 0) {
      fetchSteps(); // Fetch only if steps are not already fetched
    } // Call the function when component mounts
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [steps, editInspectObj, apiUrl, user.role_id]); // Empty dependency array ensures the effect runs only once

  //TURN ARRAY 'INSPECTIONOBJ' INTO ACTUAL OBJECT (editInspectObj)
  useEffect(() => {
    if (steps.length > 0 && editInspectObj.inspectionType === null) {
      setEditInspectObj({
        id: Number(inspectionObj[0]),
        // inventory_id: inspectionObj[1] ? Number(inspectionObj[1]) : null,
        inventory_id:
          inspectionObj[1] !== "Unknown" ? Number(inspectionObj[1]) : null,
        inspectionType:
          steps.find((step) => step.label === inspectionObj[7])?.id || null,
        description: inspectionObj[8],
        next_status:
          steps.find((step) => step.label === inspectionObj[9])?.id || null,
        // custRepairId: Number(inspectionObj[11]),
        custRepairId:
          inspectionObj[11] !== "Unknown" ? Number(inspectionObj[11]) : null,
      });
    }
  }, [steps, inspectionObj, inspections, editInspectObj]);

  //CHECK IF INIT INSPECT, IF SO FETCH INIT_INSPECTION OBJ & SET UP RETURN FORM
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (inspectionObj[10]) {
      //       console.log("inspectionObj[10]", inspectionObj[10]);
      setIsInit(true);
      const fetchInitInspectObj = async () => {
        try {
          const response = await axios.get(
            `${apiUrl}/api/init_inspection/${inspectionObj[10]}`
          );
          // console.log("response.data", response.data);
          setInitInspectObj(response.data[0]); // Store the fetched data in state
          setCurrentSection(response.data[0].currentSection);
          // setLoading(false);
        } catch (error) {
          console.error("Error fetching initial inspection data:", error);
        }
      };
      fetchInitInspectObj();
      //get and set correct 'section' based on .currentSection of retrieved init inspect obj
    } else {
      //       console.log("inspectionObj[10]", inspectionObj[10]);
      setIsInit(false);
    }
  }, [inspectionObj, apiUrl]);

  //   const clearForm = () => {
  //     setEditInspectObj((prevState) => ({
  //       userId: prevState.userId,
  //       vehicleId: "",
  //       vehicleStock: "",
  //       location: "",
  //       inspectionType: "",
  //       serviceDescription: "",
  //       nextStatus: "",
  //       date: "",
  //       init_inspect: "",
  //     }));
  //     setStockString("");
  //     setDescriptionString("");
  //     setResultString("");
  //     setSuggestedStep("");
  //   };

  //fFOR NORMAL, NON-INIT SUBMITS (to inspections)
  const handleSubmitEdit = async () => {
    console.log("editInspectObj from handleSubmitEdit", editInspectObj);

    //UPDATE THE RELEVANT INSPECTIONS ROW
    try {
      // Trigger an alert to confirm form submission
      alert("You submitted the form", editInspectObj);
      // Log the submitted inspection object to the console
      await axios.post(`${apiUrl}/api/inspection_edit`, {
        id: editInspectObj.id,
        inspectionType: editInspectObj.inspectionType,
        description: editInspectObj.description,
        next_status: editInspectObj.next_status,
        custRepairId: editInspectObj.custRepairId,
      });
      onClose();
    } catch (error) {
      console.error("Error submitting the inspection edit:", error.message);
    }

    if (hideNextOptions === false) {
      let updateData = {
        app_status: editInspectObj.next_status,
      };

      //UPDATE THE RELEVANT INVENTORY ROW
      //if from Inventory, update inventory obj .app_status
      if (editInspectObj.inventory_id !== null) {
        try {
          //edit inventory object .app_status
          const updateInventoryResponse = await axios.put(
            `${apiUrl}/api/inventory/${editInspectObj.inventory_id}`,
            updateData
          );

          if (updateInventoryResponse.status === 200) {
            alert("Vehicle status updated successfully");
          } else {
            alert("Failed to update vehicle status");
          }
        } catch (error) {
          console.error("Error updating vehicle status:", error);
          alert("Error while updating vehicle status");
        }
      } else {
        // if from customers (repair) update customer obj .cust_app_status
        try {
          const updateCustomerResponse = await axios.put(
            `${apiUrl}/api/customer/${editInspectObj.custRepairId}`,
            { nextStatus: editInspectObj.next_status } // Send nextStatus in the request body
          );

          if (updateCustomerResponse.status === 200) {
            alert("Vehicle status updated successfully");
          } else {
            alert("Failed to update vehicle status");
          }
        } catch (error) {
          console.error("Error updating vehicle status:", error);
          alert("Error while updating vehicle status");
        }
      }
      onClose();
    }
  };

  return (
    <Modal onClose={onClose} isOpen={editInspectOpen} size={SIZE.auto}>
      <ModalHeader>
        <h2>Edit Inspection</h2>
        {isInit
          ? `Type: init inspect, id:${inspectionObj[10]}`
          : `Type: ${inspectionObj[7]}`}{" "}
        | {inspectionObj[4]} | {inspectionObj[5]} | insp:
        {inspectionObj[3]} | {inspectionObj[2]}
      </ModalHeader>

      <ModalBody>
        {isInit ? (
          <InitialInspectionForm
            vehicleId={inspectionObj[0]}
            currentSection={currentSection}
            //   handleSubmitClick={handleSubmitEdit} //for 'inspections' submit
            editObj={initInspectObj} // init_inspect obj
            goingNext={editInspectObj.next_status}
            onClose={onClose}
          />
        ) : (
          <>
            <FormControl label="Inspection Type">
              <Select
                // disabled={/* isInspectionTypeDisabled */ hideNextOptions}
                disabled={true}
                options={filteredSteps}
                value={steps.filter(
                  (step) => step.id === editInspectObj.inspectionType
                )}
                placeholder="Inspection Type"
                onChange={(params) => {
                  const selectedType = params.value[0]?.id;
                  setEditInspectObj((prev) => ({
                    ...prev,
                    inspectionType: selectedType,
                  }));
                }}
              />
            </FormControl>
            <FormControl label="Describe work performed below:">
              <Textarea
                id="service-description-id"
                value={editInspectObj.description}
                onChange={(event) => {
                  const updatedDescription = event.currentTarget.value;
                  setEditInspectObj((prev) => ({
                    ...prev,
                    description: updatedDescription,
                  }));
                }}
              />
            </FormControl>
            <FormControl label="Where is vehicle going next?">
              <Select
                disabled={hideNextOptions}
                options={
                  filteredSteps /* .filter(
                  (step) => step.id !== editInspectObj.inspectionType
                ) */
                }
                value={steps.filter(
                  (step) => step.id === editInspectObj.next_status
                )}
                placeholder="Select Next Step"
                onChange={(params) => {
                  const selectedNextStatus = params.value[0]?.id;
                  setEditInspectObj((prev) => ({
                    ...prev,
                    next_status: selectedNextStatus,
                  }));
                }}
              />
            </FormControl>
            <Button
              style={{ marginRight: "1rem" }}
              type="submit"
              // onClick={handleSubmitClick}
              onClick={handleSubmitEdit}
            >
              Apply Edit
            </Button>
            {/* <Button style={{ backgroundColor: "#ff6347" }} onClick={clearForm}>
              Clear Form
            </Button> */}
          </>
        )}
      </ModalBody>
    </Modal>
  );
};

export default EditInspectModal;
